import { render, staticRenderFns } from "./DetalhesCancelamento.vue?vue&type=template&id=47b3ae4c&lang=html"
import script from "./DetalhesCancelamento.vue?vue&type=script&lang=js"
export * from "./DetalhesCancelamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports